import { Redirect, Switch } from 'react-router-dom';
import PublicRoute from '@/routes/PublicRoute';
import LoginPage from '@/components/pages/auth/login/LoginPage';
import SignupPage from '@/components/pages/auth/signup/SignupPage';
import FindAccountPage from '@/components/pages/auth/find/FindAccountPage';
import FindPasswordPage from '@/components/pages/auth/find/FindPasswordPage';
import { PATH_AUTH, PATH_AUTH_FORGOT_ACCOUNT, PATH_AUTH_FORGOT_PASSWORD, PATH_AUTH_LOGIN, PATH_AUTH_SIGNUP } from '@/constants/constant';
import { BaseTemplate } from '@/components/template';

/** @link PATH_AUTH */
const AuthRoute = () => {
  return (
    <BaseTemplate headerShow>
      <div className="mx-auto h-full min-h-screen flex flex-col justify-center items-center auth">
        <div className="w-3/4 md:w-1/2 lg:w-2/4 xl:w-1/3">
          <Switch>
            <PublicRoute restricted exact path={PATH_AUTH_SIGNUP} component={SignupPage} />
            <PublicRoute restricted exact path={PATH_AUTH_FORGOT_ACCOUNT} component={FindAccountPage} />
            <PublicRoute restricted exact path={PATH_AUTH_FORGOT_PASSWORD} component={FindPasswordPage} />
            <PublicRoute restricted path={PATH_AUTH_LOGIN} component={LoginPage} />
            <Redirect path={PATH_AUTH} to={PATH_AUTH_LOGIN} />
          </Switch>
        </div>
      </div>
    </BaseTemplate>
  );
};

export default AuthRoute;
